import { createSlice } from "@reduxjs/toolkit";

const user = createSlice({
    name: 'Applicant',
    initialState: {
        appliedJobs: [],
    },
    // initialState: userProfile,
    reducers: {
        add: (state, action) => {
            return { ...state, ...action.payload }
        },
        addAppliedJob: (state, action) => {
            const appliedDate = Date.now();
            const Status = 'Applied';
            const jobId = action.payload;

            const updateList = [...state.appliedJobs, { jobId, appliedDate, Status }];
            return { ...state, appliedJobs: updateList }
        },
        updateOpenToWork: (state, action) => {
            return { ...state, open_to_work: action.payload }
        }
    }
}
);

export const { add, addAppliedJob, updateOpenToWork } = user.actions;
export default user.reducer; 